enum ExecutionStatus {
  FINISHED = "FINISHED",
  CANCELLED = "CANCELLED",
}

export default ExecutionStatus;
